import React from 'react';
import SubCatList from './SubCatList';
import CatList from './CatList';
import * as action from '../Actions';
import Service from '../../service/Service';
const service = new Service();
// import { Bling as GPT } from "react-gpt";
import { AdSlot, DFPSlotsProvider } from 'react-dfp'

const gptAry = {

    "desktop": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Desktop_Cat-SubCat_336x280",
        slot: [[310, 100], [320, 50], [300, 250]],
        id: "div-gpt-ad-1671527785107-0",
    },
}


function readMore(e){
    if(e.target.innerText == "Read More"){
        e.target.innerText = "Read Less";
        e.target.previousSibling.style.height = "auto";
        e.target.previousSibling.classList.remove("line-clamp");
    }
    else{
        e.target.innerText = "Read More";
        e.target.previousSibling.style.height = "42px";
        e.target.previousSibling.classList.add("line-clamp");
    }
}

export default function ColoringDesktopView({ eleRef }) {
    // console.log("eleRef.props.location.pathname ===",eleRef.props.location.pathname);
    console.log("qwAGHSJDMHNXCBXV");
    return (
        <section className="coloring-desktop">
            {/* <div className="category-name">{eleRef.state.seoData[0].h1Headding}</div> */}
            {eleRef.state.seoData && eleRef.state.seoData!="" &&  eleRef.state.seoData[0].supportiveContent!="" &&
            <div className="top-catdescp"><div className="top-category-descp R14_61">
            {eleRef.state.seoData && eleRef.state.seoData[0] && eleRef.state.seoData[0].supportiveContent}
            </div>
            <span className="read-more-less M12_link" onClick={(e) => readMore(e)} role="button" tabIndex="0" aria-label="Read More about this" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') 
            e.preventDefault();
            readMore(e) }} >Read More</span></div>
            }

            {eleRef.state.landingCat &&
                <CatList catg={eleRef.state.landingCat} eleRef={eleRef} />
            }
            
            {eleRef.state.selectedCatAry && eleRef.state.selectedCatAry[0] && eleRef.state.selectedCatAry[0].subcategory &&
                <SubCatList catg={eleRef.state.selectedCatAry[0]} eleRef={eleRef} />
            }
            
            {eleRef.state.otherCategoryList &&
            <div className="category-name">Other Categories</div>
            }
            <ul className="subcategory-list">

            {eleRef.state.otherCategoryList && eleRef.state.otherCategoryList.map((subcat, index) => {
                 const imgUrl = subcat.imgUrl && subcat.imgUrl.endsWith(".jpg") 
                 ? subcat.imgUrl.replace(".jpg", ".webp") 
                 : subcat.imgUrl;
                return(
                <li key={index} className="subcatg">
                    <button
                        type="button"
                        className="subcatg-button"
                        aria-label={`View details for ${subcat.categoryName}`}
                        onClick={() => action.gotoSubCatOtherDetail(service.replaceSymbols(eleRef.props.location.pathname && eleRef.props.location.pathname.split("?")[0].split('/')[2]),service.replaceSymbols(subcat.categoryName))}
                    >
                    <div className="coloring-img">
                        {imgUrl ?
                            <img src={imgUrl} onError={(e) => { e.target.src = '/media/default-placeholder.png'; }} alt={subcat.categoryName} title={subcat.categoryName}/>
                            :
                            <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'} alt={subcat.categoryName}  title={subcat.categoryName} />
                        }
                    </div>
                    <div className="img-name">
                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Coloring-Bottom-Design.png'} alt=''></img>
                        {/* <svg viewBox="0 0 40 10">
                            <path d="M0 0 V 11 H 40 V 11 L 40 -2 Q 20 5, 0 0"></path>
                            <path d="M0 0 V 11 H 40 V 10 L 40 0 Q 20 5, 0 0"></path>
                        </svg> */}
                        <div>{subcat.categoryName}</div>
                    </div>
                    </button>
                </li>
                )
            }
                )}

            </ul>

            <div className="filter-overlay sub-category-overlay">
                <div className="filter-popup filter_popups">
                    <div className="filter_by">
                        <span className="M18_42">Filter By</span>
                        <span className="right icon" data-icon-font="C" onClick={() => action.closeFilter()}></span>
                    </div>
                    <div className="catg_filter">
                        <ul className="left">
                            <li className="category_list">
                                <ul className="left categorieslist">
                                    {eleRef.state.filterMainCategory && eleRef.state.filterMainCategory.length > 0 && eleRef.state.filterMainCategory.map((list, index) =>
                                        <li  key={index} className={(eleRef.state.filterCategoryId == list.subcategoryId) ? "gender active" : "gender"} onClick={() => action.LoadSubOfSubcategorylist(list.subcategoryId,list.subcategoryName,eleRef)}>
                                            <span className="catname R14_42">{list.subcategoryName}</span>
                                            {/*<div className="subcatCount">1 Selected</div>*/}
                                        </li>
                                    )}
                                </ul>
                            </li> 
                            <li className="subcategory_list">
                                <div className="filter_search left">
                                    <span className="icon searchflticon" data-icon-font="'" onClick={() => action.SearchCategorydata(eleRef)} ></span>
                                    <input className="R14_42" type="text" id="sabcat_search" placeholder="Search"  onChange={event => action.updateSearchInput(event,eleRef)} />
                                </div>
                                <ul className="subgender subcategorieslist active">
                                {eleRef.state.filterSubCategory && eleRef.state.filterSubCategory.length > 0 && eleRef.state.filterSubCategory.map((subCat, index) =>
                                    <li key={index} onClick={() => action.gotoDetailsPage(service.replaceSymbols(eleRef.props.location.pathname.split("?")[0].split('/')[2]),service.replaceSymbols(subCat.categoryName), service.replaceSymbols(subCat.subcategoryName),subCat.subcategoryId)}> 
                                        <input className="check left" type="checkbox" ></input>
                                        <span className="subcatname R14_42">{subCat.subcategoryName}</span>
                                    </li>
                                 )}    
                                </ul>
                            </li>
                        </ul>
                    </div>
                   
                </div>
            </div>
            <div className="category-filter-overlay">
                <div className="catg-filter">
                    <div className="catgFilter-top" role="dialog" aria-modal="true">
                        <div className="serach-field left">
                            <span data-icon-font="'" onClick={() => action.SearchCategorydata(eleRef)}></span>
                            <input type="text" placeholder="Search Category" id="categoryFilterText" onChange={event => action.updateSearchInput(event,eleRef)} />
                        </div>
                        {/* {eleRef.state.categoryListAlphabeticaly && Object.keys(eleRef.state.categoryListAlphabeticaly).map(key => ( */}
                        <div className="left alphabets-strip">
                            <span className="alpha">#</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('A') ? 'alpha' :  'active-alpha'}>A</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('B') ? 'alpha' :  'active-alpha'}>B</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('C') ? 'alpha' :  'active-alpha'}>C</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('D') ? 'alpha' :  'active-alpha'}>D</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('E') ? 'alpha' :  'active-alpha'}>E</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('F') ? 'alpha' :  'active-alpha'}>F</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('G') ? 'alpha' :  'active-alpha'}>G</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('H') ? 'alpha' :  'active-alpha'}>H</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('I') ? 'alpha' :  'active-alpha'}>I</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('J') ? 'alpha' :  'active-alpha'}>J</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('K') ? 'alpha' :  'active-alpha'}>K</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('L') ? 'alpha' :  'active-alpha'}>L</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('M') ? 'alpha' :  'active-alpha'}>M</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('N') ? 'alpha' :  'active-alpha'}>N</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('O') ? 'alpha' :  'active-alpha'}>O</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('P') ? 'alpha' :  'active-alpha'}>P</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('Q') ? 'alpha' :  'active-alpha'}>Q</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('R') ? 'alpha' :  'active-alpha'}>R</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('S') ? 'alpha' :  'active-alpha'}>S</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('T') ? 'alpha' :  'active-alpha'}>T</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('U') ? 'alpha' :  'active-alpha'}>U</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('V') ? 'alpha' :  'active-alpha'}>V</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('W') ? 'alpha' :  'active-alpha'}>W</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('X') ? 'alpha' :  'active-alpha'}>X</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('Y') ? 'alpha' :  'active-alpha'}>Y</span>
                            <span className={Object.keys(eleRef.state.categoryListAlphabeticaly).includes('Z') ? 'alpha' :  'active-alpha'}>Z</span>
                        </div>
                        {/* ))} */}
                        <div data-icon-font="C" className="close-ic right" onClick={() => action.closeCatgFilter()} role="button" tabIndex={0} aria-label="Close Filter" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ' || e.key === "Escape") action.closeCatgFilter() }}></div>
                    </div>
                    <div className="catg-list-cnt">
                        <div className="catg-list">
                            <ul className="list-colm col1">

                                {eleRef.state.categoryListAlphabeticaly && Object.keys(eleRef.state.categoryListAlphabeticaly).map(key => (
                                    <li key={`cat_${key}`}>
                                    <ul key={`cat_${key}`}>
                                    <li className="M16_21" key={`cat_${key}`}>{key}</li>
                                    {eleRef.state.categoryListAlphabeticaly[key].map((subcat, i) => {
                                       return (<li key={`cat_${i}`}>
                                        <label onClick={() => action.LoadSubcategorylist(subcat.categoryId,subcat.categoryName,eleRef)}>
                                            <input type="checkbox" className="dev_cat_sel"></input>
                                            <span className="catg-name R14_61">{subcat.categoryName} </span>
                                            <span className="R14_9e">({subcat.subcategoryCount})</span>
                                        </label>
                                    </li>) 
                                    })}
                                    </ul>
                                    </li>
                                ))}
                            </ul>
                            
                        </div>
                    </div>
                </div>
            </div>
            <p className="tncLink">
                <a href="https://parenting.firstcry.com/content-image-usage-policy/">
                Image Copyright Policy
                </a>&nbsp;
                &&nbsp;
                <a href="https://parenting.firstcry.com/terms-of-use/">
                Other T&Cs
                </a>
            </p>
            {eleRef.state.seoData && eleRef.state.seoData != "" && eleRef.state.seoData[0] && eleRef.state.seoData[0].bottomDescription!="." && eleRef.state.seoData[0].bottomDescription!="" &&
            // <div className="category-descp R14_61">
            //     {eleRef.state.seoData[0].bottomDescription}
                
            // </div>
            <div>
                {/* desktop and msite ads code for just above the paragraph in cat and subcat*/}
               {!eleRef.state.isApp ? <div className="ads">
                <div className="desktop-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                    <div style={{ textAlign: "center", padding: "5px" }} >ADVERTISEMENT</div>
                    {/* <GPT
                        adUnitPath={gptAry['desktop']['path']}
                        slotSize={gptAry['desktop']['slot']}
                        renderWhenViewable={false}
                    /> */}
                     <DFPSlotsProvider
                       adUnitPath={gptAry['desktop']['path']}
                       slotSize={gptAry['desktop']['slot']}
                       renderWhenViewable={false}
                    ></DFPSlotsProvider>
                    {/* <amp-ad width='336px' height='280px' type="doubleclick" data-slot={gptAry['desktop']['path']} data-multi-size={gptAry['desktop']['slot']}> </amp-ad> */}
                </div>

            </div> : ''} 
            
            <div className="category-descp colouring_cat_descp R14_61" dangerouslySetInnerHTML={{ __html: (eleRef.state.seoData && eleRef.state.seoData[0] && eleRef.state.seoData[0].bottomDescription) ? eleRef.state.seoData[0].bottomDescription : '' }}>
            </div>
            </div>
            }
        </section>
    )
}
